export interface Props {
  max?: string;
  min?: string;
  symbol: string;
  isFullRange: boolean;
}

const prettifyLimit = (limit?: string) => {
  const cutoff = 8;
  return limit && limit?.length > cutoff
    ? `${limit?.substring(0, cutoff)}...`
    : limit;
};

export const PositionBreakdownExplainer = ({
  symbol,
  min,
  max,
  isFullRange,
}: Props) => {
  if (isFullRange) return;
  return (
    <>
      <span className="text-xs text-center">
        Position will be 100% in {symbol} token when the price goes below{' '}
        {prettifyLimit(min)}
      </span>
      <span className="text-xs text-center">
        Position will be 100% in ETH when the price goes above{' '}
        {prettifyLimit(max)}
      </span>
    </>
  );
};
